import { createContext, use } from 'react';

import type { SiteContent } from '@/content/types';

/** Textes du site dans la langue courante. */
export const ContentContext = createContext<SiteContent | null>(null);

export function useContent(): SiteContent {
  const content = use(ContentContext);
  if (!content) throw new Error('useContent doit être utilisé sous <ContentContext>.');
  return content;
}
